import { jsx as _jsx } from "react/jsx-runtime";
import MarkdownBase from './MarkdownBase';
export function Markdown(props) {
    return /*#__PURE__*/ _jsx(MarkdownBase, {
        ...props
    });
}
